export default {
  translation: {
    'Welcome!': 'Вітаємо!'
  }
};
